import {Component} from '@angular/core';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-logout',
  imports: [],
  template: ''
})
export class LogoutComponent {
  constructor(authService: AuthService) {
    authService.logout();
  }
}
